import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * Post unavailability among the week
 * @param interval blockedInterval
 */
export default async function postBlockedInterval(interval: BlockedInterval) {
  if ("timeslot_id" in interval) {
    const res = await fetchOrchidAPI(
      `/api/scheduler/v1/unavailability/${interval.timeslot_id}`,
      {
        headers: { "content-type": "application/json" },
        method: "PUT",
        body: JSON.stringify({
          start: interval.start,
          end: interval.end,
          busy_note: interval.busy_note,
          admin_note: interval.admin_note,
        }),
      },
    );
    if (!res.ok) {
      throw new Error(
        `failed to amend blocked time interval: ${getErrorDetail(
          await res.text(),
        )}`,
      );
    }
    return;
  } else {
    const res = await fetchOrchidAPI(`/api/scheduler/v1/unavailability/`, {
      headers: { "content-type": "application/json" },
      method: "POST",
      body: JSON.stringify({
        start: interval.start,
        end: interval.end,
        busy_note: interval.busy_note,
        admin_note: interval.admin_note,
      }),
    });
    if (!res.ok) {
      throw new Error(
        `failed to create blocked time interval: ${getErrorDetail(
          await res.text(),
        )}`,
      );
    }
    return;
  }
}
